import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { _UserService } from '../services/user.service';
import { NgRedux } from '@angular-redux/store';
import { IAppState } from '../interfaces/appstate.interface';
import { PermissionActions } from '../app.actions';

import { Observable } from 'rxjs';

@Injectable()
export class AuthGuard implements CanActivate, OnInit {

  private subscription: any;
  private store: any= {};
  private sysadminSetting: any;
  constructor(private router: Router, private userService: _UserService, private ngRedux: NgRedux<IAppState>) {
    this.subscription = Observable.combineLatest([
      ngRedux.select('token'),
      ngRedux.select('clientExposure'),
      ngRedux.select('clientRule'),
      ngRedux.select('clientRebalance'),
      ngRedux.select('clientOrganization'),
      ngRedux.select('clientSystem'),
      ngRedux.select('fundAssetTrades'),
      ngRedux.select('hedgeAssetTrades'),
      ngRedux.select('sysadminSetting'),
    ]).subscribe((res) => {
      this.store['token'] = res[0]
      this.store['clientExposure'] = res[1];
      this.store['clientRule'] = res[2];
      this.store['clientRebalance'] = res[3];
      this.store['clientOrganization'] = res[4];
      this.store['clientSystem'] = res[5];
      this.store['fundAssetTrades'] = res[6];
      this.store['hedgeAssetTrades'] = res[7];
      this.sysadminSetting = res[8];
    })
  }

  ngOnInit() {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let gateKeeper: boolean = true;
    if (localStorage.getItem('loggedIn')) {
      let required = route.data.permissions;
      if( required !== undefined) {
        if(!this.sysadminSetting) {
          if (required.primary.length > 0) {
            for (let permit of required.primary) {
              if (!this.store[permit]) {
              }
            }
          }
          if (required.secondary.length > 0) {
            for (let permit of required.secondary) {
              if (!this.store[permit]) {
                gateKeeper = false;
              }
            }
          }
        }
      }
      if (gateKeeper) {
        return true;
      } else {
        this.router.navigate(['/']);
        return false;
      }
      // logged in so return true
    }
    this.router.navigate(['/login']);
    return false;
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/guards/auth.guard.ts